import "./index.scss";
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoSmallWhite from "../../assets/images/logoSmallWhite.png";
// import { faCheck } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faSkype,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="w3-container">
        <div className="w3-row">
          <div className="w3-third">
            <div className="logo">
              <Link to="https://mygradecard.online/home/">
                {/* <h2>MygradeCard</h2> */}
                <img src={logoSmallWhite} alt="NYM-white-logo" />
              </Link>
            </div>

            <p>
              MyGradeCard provides a comprehensive management system that helps
              you efficiently streamline operations
            </p>

            <div className="social">
              <Fade direction="left" delay={100} cascade>
                <ul>
                  <li>
                    <Link to="#">
                      <FontAwesomeIcon
                        icon={faLinkedin}
                        className="icon"
                        size="lg"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FontAwesomeIcon
                        icon={faInstagram}
                        className="icon"
                        size="lg"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FontAwesomeIcon
                        icon={faFacebook}
                        className="icon"
                        size="lg"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FontAwesomeIcon
                        icon={faYoutube}
                        className="icon"
                        size="lg"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FontAwesomeIcon
                        icon={faSkype}
                        className="icon"
                        size="lg"
                      />
                    </Link>
                  </li>
                </ul>
              </Fade>
            </div>
          </div>

          {/* <div className="w3-quarter w3-hide">
            <div className="links">
              <h2>Product</h2>
              <ul>
                <Fade direction="top" delay={50} triggerOnce cascade>
                  <li>
                    <Link to="#">Theme Design</Link>
                  </li>
                  <li>
                    <Link to="#">Plugins Design</Link>
                  </li>
                  <li>
                    <Link to="#">Wordpress</Link>
                  </li>
                  <li>
                    <Link to="#">Joomla Template</Link>
                  </li>
                  <li>
                    <Link to="#">Html Template</Link>
                  </li>
                </Fade>
              </ul>
            </div>
          </div> */}

          <div className="w3-third">
            <div className="links">
              <h2>Useful Links</h2>
              <ul>
                <Fade direction="top" delay={50} triggerOnce cascade>
                  {/* <li><a href="#"><Link to="">Blog</Link></a></li>
                  <li><a href="#"><Link to="">Pricing</Link></a></li>
                  <li><a href="#"><Link to="">sales</Link></a></li>
                  <li><a href="#"><Link to="">Tickets</Link></a></li>
                  <li><a href="#"><Link to="">Certification</Link></a></li> */}
                  <li>
                    <Link to="#">About Us</Link>
                  </li>
                  <li>
                    <Link to="#">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="#">Pricing</Link>
                  </li>
                  <li>
                    <Link to="#">Get Your School on Board</Link>
                  </li>
                  <li>
                    <Link to="#">Services</Link>
                  </li>
                  <li>
                    <Link to="#">Customers Service</Link>
                  </li>
                </Fade>
              </ul>
            </div>
          </div>

          <div className="w3-third w3-hid">
            <div className="links">
              <h2>Contact Info</h2>
              <Fade direction="right" delay={100} cascade>
                <p>
                  <b>Address:</b>Plot 4 Gyadi-Gyadi Court Road Kano, Nigeria
                </p>
                <p>
                  <b>Phone:</b>(+234)8099993673
                </p>
                <p>
                  <b>Email:</b> hello@mygradecard.online
                </p>
              </Fade>
            </div>
          </div>
        </div>

        <div className="w3-row">
          <div className="copy-right" align="center">
            <p>© 2023 MyGradeCard. All rights reserved</p>
            <p>
              {/* Made With ❤️ by{" "} */}
              <a href="https://astag.com/nymtechnologies">
                NYM Technologies Limited
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
